import React from "react";

import { borUrl } from "BrokerOfRecord/urls";
import LoadingPage from "Dashboard/Components/LoadingPage";
import { companyDashboardTopBarLink } from "Dashboard/EmployerUrls";
import { getAccountById } from "EntitiesApi/Selectors";
import isIntuit from "Intuit/isIntuit";
import { quotePageURL } from "QuotePage/urls";
import { connect } from "react-redux";
import Heartbeat from "ZeroRuby/snippets/heartbeat";

import { Card, CardSection, CardHeader } from "Common/Card";
import DashboardHeader from "Common/DashboardHeader";
import Footer from "Common/Footer";
import { Grid } from "Common/Grid";
import { Div } from "Common/HTML";
import ResponsiveTopBar from "Common/TopBar/ResponsiveTopBar";

import type { State } from "./store";
import type { Account, CompanyProfile } from "Utils/types";

type AccountWithMultipleCompanyProfiles = Account & {
  companyProfiles: Array<CompanyProfile>;
};

type SwitchFlowProps = {
  isLoaded: boolean;
  account: AccountWithMultipleCompanyProfiles;
  branding: "samsclub" | "square" | "intuit" | "default";
};

type SwitchPageProps = {
  account: AccountWithMultipleCompanyProfiles;
  branding: "samsclub" | "square" | "intuit" | "default";
};

export const SwitchFlowDumb = ({ isLoaded, account, branding }: SwitchFlowProps) =>
  isLoaded ? <SwitchPage account={account} branding={branding} /> : <LoadingPage />;

const SwitchPage = ({ account, branding }: SwitchPageProps) => (
  <div>
    <ResponsiveTopBar branding={branding} />

    <Div className="min-h-dvh">
      <Grid componentClass={Card} mt={5} p={0}>
        <DashboardHeader title="Please select how you would like to offer insurance" subtitle={`Signed in as: ${account.email}`} />

        {isIntuit() ? <CardHeader>Your QuickBooks Companies</CardHeader> : <CardHeader>Your Companies</CardHeader>}

        <CardSection>
          {account.companyProfiles.map((company) => {
            const token = company.idToken && company.idToken.slice(0, 16);
            if (token) {
              return (
                <div key={company.id}>
                  <b>{company.name}</b>

                  <ul>
                    <li>
                      <a href={companyDashboardTopBarLink(token)}>Company Dashboard</a>
                    </li>
                    <li>
                      <a href={quotePageURL(token)}>Quote Page</a>
                    </li>
                    <li>
                      <a href={borUrl(token)}>Broker of Record</a>
                    </li>
                  </ul>
                </div>
              );
            }
            return null;
          })}
        </CardSection>
      </Grid>
    </Div>
    <Footer />
    <Heartbeat />
  </div>
);

const mapStateToProps = (state: State) => ({
  isLoaded: state.accountId !== "",
  account: state.accountId ? getAccountById(state, state.accountId) : null,
  branding: "default",
});

const withRedux = connect(mapStateToProps);
const SwitchFlow = withRedux(SwitchFlowDumb);
export default SwitchFlow;
